import { useState, useCallback } from 'react'
import { FunctionsHttpError } from '@supabase/supabase-js'
import { supabase } from '../lib/supabase'
import { useToast } from '../components/Toast'

export type SendResult = {
  phone: string
  ok: boolean
  error?: string
  wamid?: string
}

export function useAdminMessages() {
  const toast = useToast()
  const [loading, setLoading] = useState(false)
  const [sendResults, setSendResults] = useState<SendResult[] | null>(null)

  const sendMessage = useCallback(async (message: string) => {
    setLoading(true)
    setSendResults(null)
    try {
      const { data: { session } } = await supabase.auth.getSession()
      const res = await supabase.functions.invoke('send-whatsapp-messages', {
        body: { message },
        headers: { Authorization: `Bearer ${session?.access_token}` },
      })

      if (res.error) {
        let errMsg = res.error.message
        if (res.error instanceof FunctionsHttpError) {
          try {
            const body = await res.error.context.json() as {
              error?: string
              message?: string
              meta_response_details?: { results?: SendResult[] }
            }
            const baseMsg = (body.error || body.message) || errMsg
            const firstError = body.meta_response_details?.results?.find((r) => !r.ok)
            const detail = firstError?.error ? ` Detalhe Meta: ${firstError.error}` : ''
            errMsg = baseMsg + detail
            if (body.meta_response_details?.results) {
              setSendResults(body.meta_response_details.results)
            }
          } catch { /* body not JSON */ }
        }
        throw new Error(errMsg)
      }

      const data = res.data as {
        success: boolean
        message: string
        meta_response_details?: { results?: SendResult[] }
      }

      if (data.meta_response_details?.results) {
        setSendResults(data.meta_response_details.results)
      }

      if (!data.success) {
        const firstError = data.meta_response_details?.results?.find((r) => !r.ok)
        const detail = firstError?.error ? ` Detalhe Meta: ${firstError.error}` : ''
        throw new Error((data.message || 'Falha ao enviar mensagem pela Meta.') + detail)
      }

      toast.success(data.message)
    } catch (e) {
      toast.error(e instanceof Error ? e.message : 'Falha ao enviar mensagem pela Meta.')
    } finally {
      setLoading(false)
    }
  }, [toast])

  return { sendMessage, loading, sendResults }
}
